module.exports = __webpack_public_path__ + "img/img59.b2f7f129.png";